"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureFieldBuilder = exports.CheckboxGroupFieldBuilder = exports.DynamicDropdownFieldBuilder = exports.DropdownFieldBuilder = exports.RadioFieldBuilder = exports.MoneyFieldBuilder = exports.ButtonFieldBuilder = exports.InformationFieldBuilder = exports.PhoneFieldBuilder = exports.NumberFieldBuilder = exports.ConsentFieldBuilder = exports.YearMonthFieldBuilder = exports.DateFieldBuilder = exports.TextFieldBuilder = void 0;
const uuid_1 = require("uuid");
const fieldTypes_1 = require("../../../types/carrierQuestionnaire/fieldTypes");
const questionnaireBlueprints_1 = require("../../../types/questionnaireBlueprints/questionnaireBlueprints");
const NodeBuilder_1 = __importDefault(require("./NodeBuilder"));
class FieldBlueprintBuilder extends NodeBuilder_1.default {
    constructor(nodeSeed) {
        super(nodeSeed);
        this.node.id = (0, uuid_1.v4)();
    }
    withProperties(properties) {
        Object.assign(this.node, properties);
        return this.clone();
    }
    withPartName(partname) {
        this.node.partName = partname;
        return this.clone();
    }
    withNodeId(nodeId) {
        this.node.answerNodeId = nodeId;
        return this.clone();
    }
    withTitle(title) {
        this.node.title = title;
        return this.clone();
    }
    withEffects(effects) {
        this.node.effects = effects;
        return this.clone();
    }
    withDynamicOptions(dynamicOptions) {
        this.node.dynamicOptions = dynamicOptions;
        return this.clone();
    }
    makeDisabled() {
        this.node.disabled = true;
        return this.clone();
    }
    visible(condition) {
        this.node.visible = condition;
        return this.clone();
    }
    validate(field) {
        return (0, questionnaireBlueprints_1.isFieldBlueprint)(field);
    }
}
exports.default = FieldBlueprintBuilder;
class TextFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.input,
            validateAs: questionnaireBlueprints_1.InputFieldValidations.string,
        };
        super(seed);
    }
}
exports.TextFieldBuilder = TextFieldBuilder;
class DateFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.date,
            validateAs: questionnaireBlueprints_1.DateFieldValidations.date,
        };
        super(seed);
    }
}
exports.DateFieldBuilder = DateFieldBuilder;
class YearMonthFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.date,
            validateAs: questionnaireBlueprints_1.DateFieldValidations.yearMonth,
        };
        super(seed);
    }
}
exports.YearMonthFieldBuilder = YearMonthFieldBuilder;
// TODO @QuestionnaireBuilder : Should this be an AgreeField type?
class ConsentFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.agree,
            validateAs: questionnaireBlueprints_1.BooleanFieldValidations.booleanTrue,
        };
        super(seed);
    }
}
exports.ConsentFieldBuilder = ConsentFieldBuilder;
class NumberFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.number,
            validateAs: questionnaireBlueprints_1.NumberFieldValidations.integer,
            defaultValue: undefined,
        };
        super(seed);
    }
}
exports.NumberFieldBuilder = NumberFieldBuilder;
class PhoneFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.phone,
            validateAs: questionnaireBlueprints_1.PhoneFieldValidations.phone,
        };
        super(seed);
    }
}
exports.PhoneFieldBuilder = PhoneFieldBuilder;
class InformationFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.information,
            validateAs: questionnaireBlueprints_1.StringFieldValidations.string,
        };
        super(seed);
    }
}
exports.InformationFieldBuilder = InformationFieldBuilder;
class ButtonFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.button,
            validateAs: questionnaireBlueprints_1.BooleanFieldValidations.boolean,
        };
        super(seed);
    }
}
exports.ButtonFieldBuilder = ButtonFieldBuilder;
class MoneyFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forInputField(),
            fieldType: fieldTypes_1.FieldTypes.money,
            validateAs: questionnaireBlueprints_1.MoneyFieldValidations.integer,
            defaultValue: undefined,
        };
        super(seed);
    }
}
exports.MoneyFieldBuilder = MoneyFieldBuilder;
class RadioFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        super(seedProviders.forRadioField());
    }
    withOptions(options) {
        this.node.selectOptions = options;
        return this.clone();
    }
}
exports.RadioFieldBuilder = RadioFieldBuilder;
class DropdownFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        super(seedProviders.forDropdownField());
    }
    withOptions(options) {
        this.node.selectOptions = options;
        return this.clone();
    }
}
exports.DropdownFieldBuilder = DropdownFieldBuilder;
class DynamicDropdownFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        super(seedProviders.forDropdownField());
    }
}
exports.DynamicDropdownFieldBuilder = DynamicDropdownFieldBuilder;
class CheckboxGroupFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders) {
        const seed = {
            ...seedProviders.forCheckboxField(),
            fieldType: fieldTypes_1.FieldTypes.checkboxGroup,
            validateAs: questionnaireBlueprints_1.StringFieldValidations.string,
            defaultValue: undefined,
        };
        super(seed);
    }
    withOptions(options) {
        this.node.selectOptions = options;
        return this.clone();
    }
}
exports.CheckboxGroupFieldBuilder = CheckboxGroupFieldBuilder;
class SignatureFieldBuilder extends FieldBlueprintBuilder {
    constructor(seedProviders, participantRole) {
        super(seedProviders.forSignatureField(participantRole));
    }
}
exports.SignatureFieldBuilder = SignatureFieldBuilder;
